const styles = theme => ({
  wrapperEquipItem: {
    height: '48.75px',
    width: '48.75px',
    fontSize: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1.5px',
  },
  boxEquipLabel: {
    height: '13.5px',
    padding: '1.25px 1.5px',
    borderRadius: '3.75px',
    width: '100%',
    textAlign: 'center',
  },
  maintenanceMode: {
    backgroundColor: theme.palette.tag.maintenance,
  },
  operationalStopMode: {
    backgroundColor: theme.palette.tag.operationStop,
  },
  effectiveMode: {
    backgroundColor: theme.palette.tag.operation,
  },
  inactiveMode: {
    backgroundColor: theme.palette.gray[50],
  },
  equipLabel: {
    fontSize: '9px',
    fontWeight: 500,
    height: '11px',
    color: theme.palette.common.white,
    textAlign: 'center',
    lineHeight: '11px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
  },
  equipIcon: {
    height: '33.75px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    cursor: 'pointer',
  },
  highlight: {
    animation: '$blink 1s ease-in-out 5',
  },
  '@keyframes blink': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.6 },
    '100%': { opacity: 1 },
  },
});
export default styles;
